import get from 'lodash.get';

export const selectToastList = (state) => get(state, 'toast.items', []);
